import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronUpCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	height: 48,
	viewBox: "0 0 48 48",
	width: 48,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 24,
		cy: 24,
		fill: "#009fe3",
		r: 24
	}), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		children: [/* @__PURE__ */ _jsxs("g", {
			transform: "translate(4 4)",
			children: [/* @__PURE__ */ _jsx("path", { d: "m20 0a20 20 0 1 1 -20 20 20 20 0 0 1 20-20z" }), /* @__PURE__ */ _jsx("path", {
				d: "m20 1.5c-4.94153023 0-9.58728981 1.92433929-13.08147812 5.41852188-3.49418259 3.49418831-5.41852188 8.13994789-5.41852188 13.08147812s1.92433929 9.58728981 5.41852188 13.08148193c3.49418831 3.49417878 8.13994789 5.41851807 13.08147812 5.41851807s9.58728981-1.92433929 13.08148193-5.41851807c3.49417878-3.49419212 5.41851807-8.1399517 5.41851807-13.08148193s-1.92433929-9.58728981-5.41851807-13.08147812c-3.49419212-3.49418259-8.1399517-5.41852188-13.08148193-5.41852188m0-1.5c11.04570007 0 20 8.95429993 20 20s-8.95429993 20-20 20-20-8.95429993-20-20 8.95429993-20 20-20z",
				fill: "#fff"
			})]
		}), /* @__PURE__ */ _jsx("path", {
			d: "m1411.938 147.33 10-10 10 10",
			stroke: "#fff",
			strokeMiterlimit: 10,
			strokeWidth: 1.5,
			transform: "translate(-1397.938 -119.275)"
		})]
	})]
});
export default SvgChevronUpCircle;
